import { axiosWithAuth } from 'api/axios/globalAxios';
import { makeUseAxios } from 'axios-hooks';

export const useAxiosWithAuth = makeUseAxios({
  axios: axiosWithAuth
});
